// src/index.ts
import { extendTheme } from "@chakra-ui/react";

// src/foundations/colors.ts
var basePalette = {
  colors: {
    gray: {
      50: "#F6F6F6",
      100: "#EBEBEB",
      200: "#DADADA",
      300: "#C6C6C6",
      400: "#939393",
      500: "#6F6F6F",
      600: "#525252",
      700: "#3B3B3B",
      800: "#262626",
      900: "#101010"
    },
    blackAlpha: {
      50: "rgba(0,0,0, 0.03)",
      100: "rgba(0,0,0,0.07)",
      200: "rgba(0,0,0,0.13)",
      300: "rgba(0,0,0,0.24)",
      400: "rgba(0,0,0,0.42)",
      500: "rgba(0,0,0,0.55)",
      600: "rgba(0,0,0,0.66)",
      700: "rgba(0,0,0,0.75)",
      800: "rgba(0,0,0,0.85)",
      900: "rgba(0,0,0,0.94)"
    },
    whiteAlpha: {
      50: "rgba(255,255,255, 0.03)",
      100: "rgba(255,255,255,0.07)",
      200: "rgba(255,255,255,0.13)",
      300: "rgba(255,255,255,0.24)",
      400: "rgba(255,255,255,0.42)",
      500: "rgba(255,255,255,0.55)",
      600: "rgba(255,255,255,0.66)",
      700: "rgba(255,255,255,0.75)",
      800: "rgba(255,255,255,0.85)",
      900: "rgba(255,255,255,0.94)"
    },
    red: {
      50: "#FEF4F4",
      100: "#FCE2E2",
      200: "#FBD0D0",
      300: "#F7A6A6",
      400: "#F16666",
      500: "#DB1D1D",
      600: "#A41616",
      700: "#781010",
      800: "#4F0A0A",
      900: "#260505"
    },
    orange: {
      50: "#FFF5EE",
      100: "#FFE3CE",
      200: "#FFD1B2",
      300: "#FFA76B",
      400: "#F36900",
      500: "#BD4C00",
      600: "#893B00",
      700: "#642B00",
      800: "#421B00",
      900: "#1D0C00"
    },
    yellow: {
      50: "#FFF6E2",
      100: "#FFE9BB",
      200: "#FFD17F",
      300: "#FFA328",
      400: "#E67327",
      500: "#B2551F",
      600: "#863D18",
      700: "#632B12",
      800: "#3F1C0E",
      900: "#1B0D05"
    },
    green: {
      50: "#EAFBEF",
      100: "#C5F3D6",
      200: "#9EEBB4",
      300: "#36D666",
      400: "#00AA3F",
      500: "#008226",
      600: "#006023",
      700: "#00461A",
      800: "#002D12",
      900: "#001408"
    },
    teal: {
      50: "#EBF9F8",
      100: "#CFF2F0",
      200: "#A4E6E2",
      300: "#4DCEC6",
      400: "#00A59A",
      500: "#007D75",
      600: "#005D57",
      700: "#00433F",
      800: "#002B29",
      900: "#001412"
    },
    cyan: {
      50: "#E7FAFF",
      100: "#BDF1FF",
      200: "#8CE7FF",
      300: "#04CBFF",
      400: "#009FCC",
      500: "#007999",
      600: "#005A73",
      700: "#004153",
      800: "#002A35",
      900: "#001318"
    },
    blue: {
      50: "#F0F7FF",
      100: "#D6EBFF",
      200: "#BBDEFF",
      300: "#80C1FF",
      400: "#2795FF",
      500: "#006ED7",
      600: "#0052A0",
      700: "#003B74",
      800: "#00264B",
      900: "#001122"
    },
    purple: {
      50: "#F6F6FE",
      100: "#E8E6FB",
      200: "#D8D7FB",
      300: "#B7B5F8",
      400: "#8F88EA",
      500: "#5548d9",
      600: "#473DC0",
      700: "#332C8B",
      800: "#1D1B60",
      900: "#0F0D28"
    },
    pink: {
      50: "#FDF4FE",
      100: "#F8E1FB",
      200: "#F6CDFC",
      300: "#ED9FF9",
      400: "#D960EB",
      500: "#B334C5",
      600: "#802F8C",
      700: "#5D2266",
      800: "#3F1245",
      900: "#1B0A1D"
    }
  }
};
var colors = {
  primary: basePalette.colors.purple,
  danger: basePalette.colors.red,
  warning: basePalette.colors.yellow,
  success: basePalette.colors.teal,
  info: basePalette.colors.purple,
  ...basePalette.colors
};
var colors_default = colors;

// src/foundations/shadows.ts
var shadows = {
  outline: "0 0 0 3px rgba(108, 92, 246, 0.6)"
};
var shadows_default = shadows;

// src/foundations/typography.ts
var typography = {
  fontWeights: {
    medium: 540
  },
  fontSizes: {
    "3xs": "0.625rem",
    "2xs": "0.6875rem",
    xs: "0.75rem",
    sm: "0.8125rem",
    md: "0.875rem",
    lg: "1rem",
    xl: "1.125rem",
    "2xl": "1.25rem",
    "3xl": "1.5rem",
    "4xl": "1.875rem",
    "5xl": "2.25rem",
    "6xl": "3rem",
    "7xl": "3.75rem",
    "8xl": "4.5rem",
    "9xl": "6rem"
  }
};
var typography_default = typography;

// src/foundations/sizes.ts
var sizes = {
  icon: {
    default: "1.571428571428571em",
    "3xs": "1rem",
    "2xs": "1.25rem",
    xs: "1.5rem",
    sm: "1.75rem",
    md: "2rem",
    lg: "2.25rem",
    xl: "2.5rem",
    "2xl": "3rem",
    "3xl": "3.5rem",
    "4xl": "4rem",
    "5xl": "5rem",
    "6xl": "6rem",
    "7xl": "7rem",
    "8xl": "8rem"
  }
};
var sizes_default = sizes;

// src/foundations/index.ts
var foundations = {
  colors: colors_default,
  ...typography_default,
  sizes: sizes_default,
  shadows: shadows_default
};
var foundations_default = foundations;

// src/components/accordion.ts
var Accordion = {
  baseStyle: {
    icon: {
      "&.chakra-accordion__icon": {
        boxSize: "1em"
      }
    }
  }
};
var accordion_default = Accordion;

// node_modules/@chakra-ui/anatomy/dist/chunk-OA3DH5LS.mjs
function anatomy(name, map = {}) {
  let called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function parts2(...values) {
    assert();
    for (const part of values) {
      ;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function extend(...parts22) {
    for (const part of parts22) {
      if (part in map)
        continue;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function selectors() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.selector])
    );
    return value;
  }
  function classnames() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.className])
    );
    return value;
  }
  function toPart(part) {
    const el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    const attr = el.filter(Boolean).join("__");
    const className = `chakra-${attr}`;
    const partObj = {
      className,
      selector: `.${className}`,
      toString: () => part
    };
    return partObj;
  }
  const __type = {};
  return {
    parts: parts2,
    toPart,
    extend,
    selectors,
    classnames,
    get keys() {
      return Object.keys(map);
    },
    __type
  };
}

// node_modules/@chakra-ui/anatomy/dist/chunk-GSYRQO2U.mjs
var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");
var alertAnatomy = anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");
var avatarAnatomy = anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var breadcrumbAnatomy = anatomy("breadcrumb").parts("link", "item", "container").extend("separator");
var buttonAnatomy = anatomy("button").parts();
var checkboxAnatomy = anatomy("checkbox").parts("control", "icon", "container").extend("label");
var circularProgressAnatomy = anatomy("progress").parts("track", "filledTrack").extend("label");
var drawerAnatomy = anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var editableAnatomy = anatomy("editable").parts(
  "preview",
  "input",
  "textarea"
);
var formAnatomy = anatomy("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
var formErrorAnatomy = anatomy("formError").parts("text", "icon");
var inputAnatomy = anatomy("input").parts(
  "addon",
  "field",
  "element",
  "group"
);
var listAnatomy = anatomy("list").parts("container", "item", "icon");
var menuAnatomy = anatomy("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
var modalAnatomy = anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var numberInputAnatomy = anatomy("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
var pinInputAnatomy = anatomy("pininput").parts("field");
var popoverAnatomy = anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var progressAnatomy = anatomy("progress").parts(
  "label",
  "filledTrack",
  "track"
);
var radioAnatomy = anatomy("radio").parts(
  "container",
  "control",
  "label"
);
var selectAnatomy = anatomy("select").parts("field", "icon");
var sliderAnatomy = anatomy("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
var statAnatomy = anatomy("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
var switchAnatomy = anatomy("switch").parts(
  "container",
  "track",
  "thumb"
);
var tableAnatomy = anatomy("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
var tabsAnatomy = anatomy("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
var tagAnatomy = anatomy("tag").parts(
  "container",
  "label",
  "closeButton"
);
var cardAnatomy = anatomy("card").parts(
  "container",
  "header",
  "body",
  "footer"
);

// src/components/alert.ts
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
var { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(alertAnatomy.keys);
var baseStyle = definePartsStyle((props) => {
  const { status, colorScheme } = props;
  const shouldDefault = status == void 0 || status == "loading";
  const reservedColorSchemes = colorScheme == "red" || colorScheme == "orange" || colorScheme == "green" || colorScheme == "purple" || colorScheme == "blue";
  if (!reservedColorSchemes) {
    return {
      container: {
        alignItems: "start",
        borderRadius: "md",
        py: "3.5",
        gap: "3.5",
        lineHeight: "6"
      },
      icon: {
        m: "0"
      },
      title: {
        fontWeight: "semibold"
      },
      description: {
        mr: "2"
      }
    };
  }
  return {
    container: {
      alignItems: "start",
      borderRadius: "md",
      background: `${shouldDefault ? "info" : status}-bg`,
      py: "3.5",
      gap: "3.5",
      lineHeight: "6"
    },
    icon: {
      color: `${shouldDefault ? "info" : status}`,
      m: "0"
    },
    spinner: {
      color: `${status == "loading" && "info"}`,
      my: "0.5",
      mx: "0"
    },
    title: {
      fontWeight: "semibold"
    },
    description: {
      mr: "1.5"
    }
  };
});
var Alert = defineMultiStyleConfig({
  baseStyle
});

// src/components/avatar.ts
var Avatar = {
  defaultProps: {
    size: "sm"
  }
};
var avatar_default = Avatar;

// src/components/badge.ts
import {
  defineCssVars,
  defineStyle,
  defineStyleConfig
} from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var vars = defineCssVars("badge", ["bg", "color", "shadow"]);
var baseStyle2 = defineStyle({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var variantSubtle = defineStyle((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  const darkBg = transparentize(`${c}.200`, 0.16)(theme2);
  return {
    [vars.bg.variable]: `colors.${c}.100`,
    [vars.color.variable]: `colors.${c}.700`,
    _dark: {
      [vars.bg.variable]: darkBg,
      [vars.color.variable]: `colors.${c}.200`
    }
  };
});
var variants = {
  subtle: variantSubtle
};
var Badge = defineStyleConfig({
  baseStyle: baseStyle2,
  variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "neutral"
  }
});
var badge_default = Badge;

// src/components/breadcrumb.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers2 } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle2, defineMultiStyleConfig: defineMultiStyleConfig2 } = createMultiStyleConfigHelpers2(breadcrumbAnatomy.keys);
var baseStyle3 = definePartsStyle2({
  link: {
    color: "chakra-subtle-text"
  },
  separator: {
    color: "chakra-subtle-text"
  }
});
var Breadcrumb = defineMultiStyleConfig2({ baseStyle: baseStyle3 });

// src/components/button.ts
import { defineStyle as defineStyle2, defineStyleConfig as defineStyleConfig2 } from "@chakra-ui/styled-system";
import { mode, transparentize as transparentize2 } from "@chakra-ui/theme-tools";

// node_modules/@chakra-ui/utils/dist/chunk-Y5FGD7DM.mjs
function isFunction(value) {
  return typeof value === "function";
}
var __DEV__ = process.env.NODE_ENV !== "production";
var __TEST__ = process.env.NODE_ENV === "test";

// node_modules/@chakra-ui/utils/dist/chunk-M3TFMUOL.mjs
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}

// src/components/button.ts
var parts = ["button", "icon"];
var baseStyle4 = defineStyle2({
  rounded: "full"
});
var variantGhost = defineStyle2((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  if (c === "gray" || c === null) {
    return {
      color: "neutral-fg",
      _hover: {
        bg: "neutral-bg"
      },
      _active: { bg: "neutral-bg-active" }
    };
  }
  const darkHoverBg = transparentize2(`${c}.200`, 0.12)(theme2);
  const darkActiveBg = transparentize2(`${c}.200`, 0.24)(theme2);
  return {
    color: mode(`${c}.600`, `${c}.200`)(props),
    bg: "transparent",
    _hover: {
      bg: mode(`${c}.100`, darkHoverBg)(props)
    },
    _active: {
      bg: mode(`${c}.200`, darkActiveBg)(props)
    }
  };
});
var variantOutline = defineStyle2((props) => {
  const { colorScheme: c } = props;
  const borderColor = "chakra-border-color";
  return {
    border: "1px solid",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none !important"
    },
    borderColor: "chakra-border-color",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...runIfFn(variantGhost, props)
  };
});
var accessibleColorMap = {
  yellow: {
    bg: "yellow.300",
    color: "chakra-body-text",
    hoverBg: "yellow.400",
    activeBg: "yellow.500"
  },
  cyan: {
    bg: "cyan.300",
    color: "chakra-body-text",
    hoverBg: "cyan.400",
    activeBg: "cyan.500"
  },
  warning: {
    bg: "warning.300",
    color: "chakra-body-text",
    hoverBg: "warning.400",
    activeBg: "warning.500"
  }
};
var variantSolid = defineStyle2((props) => {
  const { colorScheme: c } = props;
  if (c === "gray") {
    const bg2 = mode(`gray.100`, `whiteAlpha.200`)(props);
    return {
      bg: bg2,
      color: "chakra-body-text",
      _hover: {
        bg: mode(`gray.200`, `whiteAlpha.300`)(props),
        _disabled: {
          bg: bg2
        }
      },
      _active: { bg: mode(`gray.300`, `whiteAlpha.400`)(props) }
    };
  }
  if (c === null) {
    const bg2 = mode(`primary.500`, `primary.200`)(props);
    return {
      bg: bg2,
      color: "chakra-inverse-text",
      _hover: {
        bg: mode(`primary.600`, `primary.300`)(props),
        _disabled: {
          bg: bg2
        }
      },
      _active: { bg: mode(`primary.700`, `primary.400`)(props) }
    };
  }
  const {
    bg = `${c}.500`,
    color = "white",
    hoverBg = `${c}.600`,
    activeBg = `${c}.700`
  } = accessibleColorMap[c] ?? {};
  const background2 = mode(bg, `${c}.200`)(props);
  return {
    bg: background2,
    color: mode(color, `blackAlpha.900`)(props),
    _hover: {
      bg: mode(hoverBg, `${c}.300`)(props),
      _disabled: {
        bg: background2
      }
    },
    _active: { bg: mode(activeBg, `${c}.400`)(props) }
  };
});
var variantLink = defineStyle2((props) => {
  const { colorScheme: c } = props;
  if (c === "gray" || c === null) {
    return {
      color: mode(`primary.500`, `primary.200`)(props),
      lineHeight: "inherit",
      _hover: {
        textDecoration: "underline",
        _disabled: {
          textDecoration: "none"
        }
      },
      _active: {
        color: mode(`primary.700`, `primary.400`)(props)
      }
    };
  }
  return {
    padding: 0,
    height: "auto",
    lineHeight: "inherit",
    verticalAlign: "baseline",
    color: mode(`${c}.500`, `${c}.200`)(props),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: mode(`${c}.700`, `${c}.500`)(props)
    }
  };
});
var variantGhostColorOnHover = defineStyle2((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  if (c === "gray") {
    return {
      color: mode(`gray.800`, `whiteAlpha.900`)(props),
      _hover: {
        bg: mode(`gray.100`, `whiteAlpha.200`)(props)
      },
      _active: { bg: mode(`gray.200`, `whiteAlpha.300`)(props) }
    };
  }
  const darkHoverBg = transparentize2(`${c}.200`, 0.12)(theme2);
  const darkActiveBg = transparentize2(`${c}.200`, 0.24)(theme2);
  return {
    color: "neutral-fg",
    bg: "transparent",
    _hover: {
      color: mode(`${c}.600`, `${c}.200`)(props),
      bg: mode(`${c}.100`, darkHoverBg)(props),
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    },
    _active: {
      color: mode(`${c}.600`, `${c}.200`)(props),
      bg: mode(`${c}.200`, darkActiveBg)(props),
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    }
  };
});
var variants2 = {
  ghost: variantGhost,
  outline: variantOutline,
  solid: variantSolid,
  link: variantLink,
  ghostColorOnHover: variantGhostColorOnHover,
  toggle: {
    color: "neutral-fg",
    _hover: {
      bg: "neutral-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    },
    _active: {
      color: "primary-fg",
      bg: "primary-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    }
  },
  navigation: {
    fontWeight: "medium",
    px: "2.5",
    justifyContent: "none",
    rounded: "md",
    color: "neutral-fg",
    _hover: {
      bg: "neutral-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    },
    _active: {
      color: "primary-fg",
      bg: "primary-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    }
  },
  pagination: {
    fontWeight: "medium",
    px: "1.5",
    color: "neutral-fg",
    _hover: {
      bg: "neutral-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    },
    _active: {
      color: "primary-fg",
      bg: "primary-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    }
  },
  filter: {
    px: "3",
    color: "neutral-fg",
    rounded: "md",
    border: "1px solid",
    borderColor: "chakra-border-color",
    _hover: {
      bg: "neutral-bg",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    },
    _active: {
      bg: "primary-bg",
      color: "primary-fg",
      rounded: "md",
      _disabled: {
        bg: "none",
        color: "neutral-fg"
      }
    }
  },
  ai: {
    transitionProperty: "background",
    color: "chakra-inverse-text",
    bgGradient: "linear(to-tr, purple, teal)",
    _hover: {
      bgGradient: "linear(to-tr, purple.600, teal.600)",
      _disabled: {
        bgGradient: "linear(to-tr, purple, teal)"
      }
    },
    _active: {
      bgGradient: "linear(to-tr, purple.700, teal.700)",
      _disabled: {
        bgGradient: "linear(to-tr, purple, teal)"
      }
    },
    _dark: {
      _hover: {
        bgGradient: "linear(to-tr, purple.300, teal.300)",
        _disabled: {
          bgGradient: "linear(to-tr, purple, teal)"
        }
      },
      _active: {
        bgGradient: "linear(to-tr, purple.400, teal.400)",
        _disabled: {
          bgGradient: "linear(to-tr, purple, teal)"
        }
      }
    }
  }
};
var Button = defineStyleConfig2({
  ...parts,
  baseStyle: baseStyle4,
  variants: variants2,
  defaultProps: {
    colorScheme: null
  },
  sizes: {
    sm: {
      fontSize: "md"
    },
    lg: {
      fontSize: "md"
    }
  }
});

// src/components/card.ts
var Card = {
  sizes: {
    lg: {
      container: {
        rounded: "lg"
      }
    }
  },
  variants: {
    filled: {
      container: {
        bg: "neutral-color.50"
      }
    },
    flat: {
      container: {
        shadow: "sm"
      }
    },
    outlineRaised: {
      container: {
        shadow: "sm",
        borderWidth: "1px",
        borderColor: "chakra-border-color"
      }
    }
  }
};

// src/components/checkbox.ts
var Checkbox = {
  baseStyle: {
    control: {
      borderColor: "border-color-a11y",
      bg: "chakra-body-bg",
      _disabled: {
        bg: "neutral-color.200",
        borderColor: "transparent"
      },
      _checked: {
        _disabled: {
          bg: "neutral-color.200",
          borderColor: "transparent",
          color: "chakra-subtle-text"
        }
      }
    }
  },
  defaultProps: {
    colorScheme: "primary",
    size: "lg"
  },
  sizes: {
    lg: {
      label: { fontSize: "md" }
    },
    xl: {
      control: {
        boxSize: "6"
      },
      icon: {
        fontSize: "xs"
      }
    }
  },
  variants: {
    round: {
      control: {
        rounded: "full"
      }
    }
  }
};
var checkbox_default = Checkbox;

// src/components/close-button.ts
var CloseButton = {
  baseStyle: {
    rounded: "full",
    opacity: "0.75",
    _hover: { opacity: "1" }
  },
  sizes: {
    sm: { fontSize: "3xs" }
  }
};

// src/components/code.ts
import {
  defineCssVars as defineCssVars2,
  defineStyle as defineStyle3,
  defineStyleConfig as defineStyleConfig3
} from "@chakra-ui/styled-system";
import { transparentize as transparentize3 } from "@chakra-ui/theme-tools";
var vars2 = defineCssVars2("badge", ["bg", "color", "shadow"]);
var variantSubtle2 = defineStyle3((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  const darkBg = transparentize3(`${c}.200`, 0.16)(theme2);
  return {
    [vars2.bg.variable]: `colors.${c}.50`,
    [vars2.color.variable]: `colors.${c}.800`,
    _dark: {
      [vars2.bg.variable]: darkBg,
      [vars2.color.variable]: `colors.${c}.200`
    }
  };
});
var variants3 = {
  subtle: variantSubtle2
};
var Code = defineStyleConfig3({
  variants: variants3,
  defaultProps: {
    variant: "subtle",
    colorScheme: "neutral"
  }
});

// src/components/container.ts
var Container = {
  baseStyle: {
    p: "0"
  }
};
var container_default = Container;

// src/components/divider.ts
var Divider = {
  baseStyle: {
    opacity: "1"
  }
};
var divider_default = Divider;

// src/components/drawer.ts
var Drawer = {
  defaultProps: {
    size: "md"
  },
  baseStyle: {
    header: { py: "5", px: "7" },
    body: { px: "7" },
    footer: { py: "5", px: "7" },
    closeButton: { top: "3", insetEnd: "3" },
    overlay: {
      bg: "blackAlpha.500"
    }
  }
};
var drawer_default = Drawer;

// src/components/form.ts
var Form = {
  parts: ["helperText"],
  baseStyle: (props) => ({
    helperText: {
      color: "chakra-subtle-text"
    }
  })
};
var form_default = Form;

// src/components/form-error.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers3 } from "@chakra-ui/styled-system";
var { definePartsStyle: definePartsStyle3, defineMultiStyleConfig: defineMultiStyleConfig3 } = createMultiStyleConfigHelpers3(formErrorAnatomy.keys);
var FormError = defineMultiStyleConfig3({
  baseStyle: {
    icon: {
      "&.chakra-form__error-icon": {
        boxSize: "1em"
      }
    }
  }
});

// src/components/form-label.ts
var FormLabel = {
  baseStyle: {
    color: "neutral-fg"
  },
  variants: {
    small: { fontSize: "sm", mb: "1" }
  }
};
var form_label_default = FormLabel;

// src/components/heading.ts
import { defineStyleConfig as defineStyleConfig4 } from "@chakra-ui/react";
var Heading = defineStyleConfig4({
  baseStyle: {
    fontWeight: "semibold"
  },
  sizes: {
    sm: {
      fontSize: "lg"
    }
  },
  variants: {
    section: {
      color: "chakra-subtle-text",
      textTransform: "uppercase",
      fontSize: "sm"
    }
  }
});

// src/components/input.ts
var Input = {
  baseStyle: {
    element: {
      color: "neutral-fg"
    }
  },
  sizes: {
    sm: { field: { fontSize: "md" }, addon: { fontSize: "md" } },
    lg: { field: { fontSize: "md" }, addon: { fontSize: "md" } }
  },
  variants: {
    outline: {
      field: {
        borderColor: "border-color-a11y",
        bg: "chakra-body-bg",
        _hover: {
          borderColor: "neutral-color.600"
        },
        _focusVisible: {
          borderColor: "primary.500",
          boxShadow: "0 0 0 1px var(--colors-primary-500)",
          _dark: {
            borderColor: "primary.300",
            boxShadow: "0 0 0 1px var(--colors-primary-300)"
          }
        }
      },
      addon: {
        bg: "chakra-subtle-bg",
        borderColor: "border-color-a11y"
      }
    },
    filled: {
      field: {
        bg: "neutral-color.100",
        _hover: {
          bg: "neutral-color.200"
        },
        _focusVisible: {
          borderColor: "primary.500",
          _dark: {
            borderColor: "primary.300"
          }
        }
      }
    },
    flushed: {
      field: {
        borderColor: "border-color-a11y",
        _hover: {
          borderColor: "neutral-color.600"
        },
        _focusVisible: {
          borderColor: "primary.500",
          boxShadow: "0 1px 0 0 var(--colors-primary-500)",
          _dark: {
            borderColor: "primary.300",
            boxShadow: "0 1px 0 0 var(--colors-primary-300)"
          },
          _hover: {
            borderColor: "primary.500"
          }
        }
      }
    }
  },
  defaultProps: {
    focusBorderColor: "primary.500"
  }
};

// src/components/link.ts
var Link = {
  baseStyle: {
    color: "primary"
  }
};
var link_default = Link;

// src/components/list.ts
var List = {
  baseStyle: {
    icon: {
      color: "chakra-subtle-text",
      verticalAlign: "middle",
      mt: "-0.5"
    }
  }
};
var list_default = List;

// src/components/menu.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers4 } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle4, defineMultiStyleConfig: defineMultiStyleConfig4 } = createMultiStyleConfigHelpers4(menuAnatomy.keys);
var baseStyle5 = definePartsStyle4({
  button: {},
  list: {
    shadow: "md",
    _dark: {
      shadow: "dark-lg"
    }
  },
  item: {
    py: "2",
    px: "3.5",
    ".chakra-menu__icon-wrapper": {
      fontSize: "inherit",
      color: "neutral-fg"
    }
  },
  groupTitle: {
    color: "chakra-subtle-text",
    textTransform: "uppercase",
    mx: "none",
    my: "none",
    py: "2",
    px: "3.5"
  },
  command: {},
  divider: {}
});
var Menu = defineMultiStyleConfig4({ baseStyle: baseStyle5 });
var menu_default = Menu;

// src/components/modal.ts
var Modal = {
  baseStyle: {
    dialogContainer: {},
    dialog: {
      rounded: "lg"
    },
    header: {
      py: "5",
      px: "7"
    },
    body: {
      px: "7"
    },
    footer: {
      py: "5",
      px: "7"
    },
    closeButton: {
      top: "3",
      insetEnd: "3"
    },
    overlay: {
      bg: "blackAlpha.500"
    }
  },
  sizes: {
    max: {
      dialog: {
        maxW: "100vw",
        minH: "full",
        my: "0",
        rounded: ["none", "lg"]
      },
      dialogContainer: {
        p: ["none", "4"]
      }
    },
    full: {
      dialog: {
        rounded: "none"
      }
    }
  }
};
var modal_default = Modal;

// src/components/number-input.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers5 } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle5, defineMultiStyleConfig: defineMultiStyleConfig5 } = createMultiStyleConfigHelpers5(numberInputAnatomy.keys);
var baseStyle6 = definePartsStyle5({
  stepper: {
    "& svg": {
      boxSize: "1em"
    }
  }
});
var outline = definePartsStyle5({
  field: {
    borderColor: "border-color-a11y",
    bg: "chakra-body-bg",
    _hover: {
      borderColor: "neutral-color.600"
    },
    _focusVisible: {
      borderColor: "primary.500",
      boxShadow: "0 0 0 1px var(--colors-primary-500)",
      _dark: {
        borderColor: "primary.300",
        boxShadow: "0 0 0 1px var(--colors-primary-300)"
      }
    }
  }
});
var NumberInput = defineMultiStyleConfig5({
  baseStyle: baseStyle6,
  variants: { outline }
});

// src/components/progress.ts
import {
  createMultiStyleConfigHelpers as createMultiStyleConfigHelpers6,
  defineStyle as defineStyle4
} from "@chakra-ui/styled-system";
import { generateStripe, getColor, mode as mode2 } from "@chakra-ui/theme-tools";
var { defineMultiStyleConfig: defineMultiStyleConfig6, definePartsStyle: definePartsStyle6 } = createMultiStyleConfigHelpers6(progressAnatomy.keys);
var filledStyle = defineStyle4((props) => {
  const { colorScheme: c, theme: t, isIndeterminate, hasStripe } = props;
  const stripeStyle = mode2(
    generateStripe(),
    generateStripe("1rem", "rgba(0,0,0,0.1)")
  )(props);
  const bgColor = mode2(`${c}.500`, `${c}.200`)(props);
  const gradient = `linear-gradient(
    to right,
    ${getColor(t, bgColor)} 0%,
    ${getColor(t, bgColor)} 50%,
    ${getColor(t, bgColor)} 100%
  )`;
  const addStripe = !isIndeterminate && hasStripe;
  return {
    ...addStripe && stripeStyle,
    ...isIndeterminate ? { bgImage: gradient } : { bgColor }
  };
});
var baseStyleLabel = defineStyle4({
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white",
  borderRadius: "full"
});
var baseStyleTrack = defineStyle4((props) => {
  return {
    bg: "neutral-color.100",
    borderRadius: "full"
  };
});
var baseStyleFilledTrack = defineStyle4((props) => {
  return {
    transitionProperty: "common",
    transitionDuration: "slow",
    ...filledStyle(props),
    borderRadius: "full"
  };
});
var baseStyle7 = definePartsStyle6((props) => ({
  label: baseStyleLabel,
  filledTrack: baseStyleFilledTrack(props),
  track: baseStyleTrack(props)
}));
var variants4 = {
  ai: {
    filledTrack: {
      bgGradient: "linear(to-r, purple.400, teal.400)",
      _dark: {
        bgGradient: "linear(to-r, purple, teal)"
      }
    }
  }
};
var Progress = defineMultiStyleConfig6({
  baseStyle: baseStyle7,
  variants: variants4,
  defaultProps: {
    colorScheme: "primary"
  }
});

// src/components/radio.ts
var Radio = {
  baseStyle: {
    control: {
      borderColor: "border-color-a11y",
      bg: "chakra-body-bg",
      _disabled: {
        bg: "neutral-color.200",
        borderColor: "transparent"
      },
      _checked: {
        _disabled: {
          bg: "neutral-color.200",
          borderColor: "transparent",
          color: "chakra-subtle-text"
        }
      }
    }
  },
  defaultProps: {
    colorScheme: "primary",
    size: "lg"
  },
  sizes: {
    lg: {
      label: { fontSize: "md" }
    },
    xl: {
      control: {
        boxSize: "6"
      }
    }
  }
};
var radio_default = Radio;

// src/components/select.ts
var Select = {
  sizes: {
    sm: { field: { fontSize: "md" } },
    lg: { field: { fontSize: "md" } }
  },
  variants: {
    outline: {
      field: {
        borderColor: "border-color-a11y",
        bg: "chakra-body-bg",
        _hover: {
          borderColor: "neutral-color.600"
        },
        _focusVisible: {
          borderColor: "primary.500",
          boxShadow: "0 0 0 1px var(--colors-primary-500)",
          _dark: {
            borderColor: "primary.300",
            boxShadow: "0 0 0 1px var(--colors-primary-300)"
          }
        }
      }
    },
    filled: {
      field: {
        _focusVisible: {
          borderColor: "primary.500",
          _dark: {
            borderColor: "primary.300"
          }
        }
      }
    }
  }
};
var select_default = Select;

// src/components/skeleton.ts
import { cssVar, defineStyle as defineStyle5, defineStyleConfig as defineStyleConfig5 } from "@chakra-ui/react";
var $startColor = cssVar("skeleton-start-color");
var $endColor = cssVar("skeleton-end-color");
var baseStyle8 = defineStyle5({
  _light: {
    [$startColor.variable]: "colors.blackAlpha.100",
    [$endColor.variable]: "colors.blackAlpha.300"
  },
  _dark: {
    [$startColor.variable]: "colors.whiteAlpha.100",
    [$endColor.variable]: "colors.whiteAlpha.300"
  }
});
var Skeleton = defineStyleConfig5({ baseStyle: baseStyle8 });

// src/components/slider.ts
var Slider = {
  defaultProps: {
    colorScheme: "primary"
  },
  baseStyle: {
    track: { bg: "neutral-color.200" }
  }
};
var slider_default = Slider;

// src/components/spinner.ts
var Spinner = {};
var spinner_default = Spinner;

// src/components/stepper.ts
var Stepper = {
  defaultProps: {
    colorScheme: "primary"
  }
};
var stepper_default = Stepper;

// src/components/switch.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers7, defineStyle as defineStyle6 } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle7, defineMultiStyleConfig: defineMultiStyleConfig7 } = createMultiStyleConfigHelpers7(switchAnatomy.keys);
var baseStyleTrack2 = defineStyle6((props) => {
  const { colorScheme: c } = props;
  return {
    bg: `border-color-a11y`,
    _checked: {
      bg: `${c}.500`
    },
    _dark: {
      bg: `whiteAlpha.400`,
      _checked: {
        bg: `${c}.200`
      }
    }
  };
});
var baseStyle9 = definePartsStyle7((props) => ({
  container: {},
  thumb: {},
  track: baseStyleTrack2(props)
}));
var defaultProps = {
  colorScheme: "success"
};
var Switch = defineMultiStyleConfig7({ baseStyle: baseStyle9, defaultProps });
var switch_default = Switch;

// src/components/table.ts
var Table = {
  baseStyle: {
    tr: {
      th: {
        fontSize: "sm",
        textTransform: "none",
        letterSpacing: "normal",
        fontWeight: "semibold",
        color: "neutral-fg"
      },
      td: {
        lineHeight: "unset"
      },
      "&[href]:hover": {
        td: {
          backgroundColor: "blackAlpha.50"
        }
      }
    }
  },
  defaultProps: {
    colorScheme: "neutral"
  },
  variants: {
    striped: {
      tr: {
        td: {
          border: "none"
        }
      }
    }
  },
  sizes: {
    md: {
      th: { py: "3" },
      td: { fontSize: "md" }
    }
  }
};
var table_default = Table;

// src/components/tabs.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers8, theme } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle8, defineMultiStyleConfig: defineMultiStyleConfig8 } = createMultiStyleConfigHelpers8(tabsAnatomy.keys);
var baseStyle10 = definePartsStyle8({
  tablist: {
    color: "neutral-fg"
  },
  tab: {
    fontWeight: "semibold"
  }
});
var softRounded = definePartsStyle8((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  return {
    ...(_d = (_c = (_b = (_a = theme) == null ? void 0 : _a.components) == null ? void 0 : _b.Tabs) == null ? void 0 : _c.variants) == null ? void 0 : _d["soft-rounded"](props),
    tab: {
      ...(_h = (_g = (_f = (_e = theme) == null ? void 0 : _e.components) == null ? void 0 : _f.Tabs) == null ? void 0 : _g.variants) == null ? void 0 : _h["soft-rounded"](props).tab,
      color: "neutral-fg",
      _selected: {
        ...(_l = (_k = (_j = (_i = theme) == null ? void 0 : _i.components) == null ? void 0 : _j.Tabs) == null ? void 0 : _k.variants) == null ? void 0 : _l["soft-rounded"](props).tab._selected
      }
    }
  };
});
var solidRounded = definePartsStyle8((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  return {
    ...(_d = (_c = (_b = (_a = theme) == null ? void 0 : _a.components) == null ? void 0 : _b.Tabs) == null ? void 0 : _c.variants) == null ? void 0 : _d["solid-rounded"](props),
    tab: {
      ...(_h = (_g = (_f = (_e = theme) == null ? void 0 : _e.components) == null ? void 0 : _f.Tabs) == null ? void 0 : _g.variants) == null ? void 0 : _h["solid-rounded"](props).tab,
      color: "neutral-fg",
      _selected: {
        ...(_l = (_k = (_j = (_i = theme) == null ? void 0 : _i.components) == null ? void 0 : _j.Tabs) == null ? void 0 : _k.variants) == null ? void 0 : _l["solid-rounded"](props).tab._selected,
        color: "white"
      }
    }
  };
});
var variants5 = {
  "soft-rounded": softRounded,
  "solid-rounded": solidRounded
};
var Tabs = defineMultiStyleConfig8({
  baseStyle: baseStyle10,
  variants: variants5,
  defaultProps: {
    colorScheme: "primary"
  }
});

// src/components/tag.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers9 } from "@chakra-ui/react";
var { definePartsStyle: definePartsStyle9, defineMultiStyleConfig: defineMultiStyleConfig9 } = createMultiStyleConfigHelpers9(tagAnatomy.keys);
var baseStyle11 = definePartsStyle9({
  container: {
    fontWeight: "normal",
    "& .chakra-icon": {
      boxSize: "1.25em"
    }
  },
  closeButton: {
    "& .chakra-icon": {
      height: "initial",
      width: "initial"
    }
  }
});
var sizes2 = {
  sm: {
    container: {
      fontSize: "sm",
      px: "1.5"
    }
  },
  md: {
    container: {
      fontSize: "md"
    }
  },
  lg: {
    container: {
      fontSize: "md"
    }
  }
};
var Tag = defineMultiStyleConfig9({
  baseStyle: baseStyle11,
  sizes: sizes2,
  defaultProps: {
    colorScheme: "neutral"
  }
});

// src/components/text.ts
var Text = {
  variants: {
    strong: {
      fontWeight: "semibold"
    },
    subtle: {
      color: "chakra-subtle-text"
    },
    small: {
      color: "chakra-subtle-text",
      fontSize: "sm"
    },
    tiny: {
      color: "chakra-subtle-text",
      fontSize: "xs"
    },
    large: {
      fontSize: "lg"
    }
  }
};
var text_default = Text;

// src/components/textarea.ts
var Textarea = {
  variants: {
    outline: {
      borderColor: "border-color-a11y",
      bg: "chakra-body-bg",
      _hover: {
        borderColor: "neutral-color.600"
      },
      _focusVisible: {
        borderColor: "primary.500",
        boxShadow: "0 0 0 1px var(--colors-primary-500)",
        _dark: {
          borderColor: "primary.300",
          boxShadow: "0 0 0 1px var(--colors-primary-300)"
        }
      }
    }
  }
};
var textarea_default = Textarea;

// src/components/icon.ts
import { defineStyle as defineStyle7, defineStyleConfig as defineStyleConfig6 } from "@chakra-ui/styled-system";
import { mode as mode3, transparentize as transparentize4 } from "@chakra-ui/theme-tools";
var baseStyle12 = defineStyle7((props) => {
  const { color: c, layerStyle: ls, boxSize: bs } = props;
  const stripColorRange = (c == null ? void 0 : c.replace(/\..*/, "")) !== void 0 ? c == null ? void 0 : c.replace(/\..*/, "") : c;
  const stylesBasedOnLayerStyle = {
    "icon.solid": {
      bgColor: mode3(
        `${stripColorRange}.500`,
        `${stripColorRange}.200`
      )(props),
      color: "chakra-inverse-text"
    },
    "icon.subtle": {
      bgColor: mode3(
        `${stripColorRange}.100`,
        transparentize4(stripColorRange + ".200", 0.12)
      )(props),
      color: mode3(
        `${stripColorRange}.600`,
        `${stripColorRange}.200`
      )(props)
    }
  };
  const stylesBasedOnSize = {
    "icon.3xs": { rounded: "sm", padding: 0.5 },
    "icon.2xs": { rounded: "base", padding: 0.5 },
    "icon.xs": { rounded: "base", padding: 0.5 },
    "icon.sm": { rounded: "base", padding: 1 },
    "icon.md": { rounded: "base", padding: 1 },
    "icon.lg": { rounded: "md", padding: 1.5 },
    "icon.xl": { rounded: "md", padding: 1.5 },
    "icon.2xl": { rounded: "md", padding: 2 },
    "icon.3xl": { rounded: "lg", padding: 2.5 },
    "icon.4xl": { rounded: "lg", padding: 3 },
    "icon.5xl": { rounded: "xl", padding: 3.5 },
    "icon.6xl": { rounded: "xl", padding: 4 },
    "icon.7xl": { rounded: "2xl", padding: 5 },
    "icon.8xl": { rounded: "2xl", padding: 6 }
  };
  return {
    ...stylesBasedOnSize[bs],
    ...stylesBasedOnLayerStyle[ls],
    boxSize: "icon.default",
    "& path": {
      fill: "currentColor"
    }
  };
});
var Icon = defineStyleConfig6({
  baseStyle: baseStyle12
});

// src/components/index.ts
var components = {
  Accordion: accordion_default,
  Alert,
  Avatar: avatar_default,
  Badge: badge_default,
  Breadcrumb,
  Button,
  Card,
  Checkbox: checkbox_default,
  CloseButton,
  Code,
  Container: container_default,
  Divider: divider_default,
  Drawer: drawer_default,
  Form: form_default,
  FormError,
  FormLabel: form_label_default,
  Heading,
  Icon,
  Input,
  Link: link_default,
  List: list_default,
  Menu: menu_default,
  Modal: modal_default,
  NumberInput,
  Progress,
  Radio: radio_default,
  Select: select_default,
  Skeleton,
  Slider: slider_default,
  Spinner: spinner_default,
  Stepper: stepper_default,
  Switch: switch_default,
  Table: table_default,
  Tabs,
  Tag,
  Textarea: textarea_default,
  Text: text_default
};
var components_default = components;

// src/styles.ts
var styles = {
  global: {
    body: {
      fontSize: "md"
    },
    strong: {
      fontWeight: "semibold"
    }
  }
};
var styles_default = styles;

// src/layer-styles.ts
var layerStyles = {
  section: {
    topbar: {
      bg: "chakra-body-bg",
      px: "4",
      h: "14",
      shadow: "base"
    },
    main: {
      w: "full",
      bg: "chakra-body-bg",
      pt: ["5", "7", "9"],
      px: ["6", "8", "10"],
      pb: ["7", "9", "12"]
    },
    sidebar: {
      bg: "chakra-subtle-bg",
      padding: "5",
      bgGradient: "linear(to-r, transparent calc(100% - 4px), rgba(0,0,0,0.01) calc(100% - 1px),  blackAlpha.100)"
    }
  },
  interactive: {
    raise: {
      cursor: "pointer",
      transitionProperty: "common",
      transitionDuration: "normal",
      _hover: { shadow: "md" },
      _active: { shadow: "base" }
    },
    fill: {
      cursor: "pointer",
      transitionProperty: "common",
      transitionDuration: "normal",
      _hover: {
        bgGradient: "linear(neutral-color.50, neutral-color.50)"
      },
      _active: {
        bgGradient: "linear(neutral-color.100, neutral-color.100)"
      }
    }
  },
  menuButtonIcon: {
    mx: "-1.5",
    p: "0.5"
  }
};
var layer_styles_default = layerStyles;

// node_modules/@ctrl/tinycolor/dist/module/util.js
function bound01(n, max) {
  if (isOnePointZero(n)) {
    n = "100%";
  }
  const isPercent = isPercentage(n);
  n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
  if (isPercent) {
    n = parseInt(String(n * max), 10) / 100;
  }
  if (Math.abs(n - max) < 1e-6) {
    return 1;
  }
  if (max === 360) {
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
  } else {
    n = n % max / parseFloat(String(max));
  }
  return n;
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function isOnePointZero(n) {
  return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") !== -1;
}
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}
function convertToPercentage(n) {
  if (Number(n) <= 1) {
    return `${Number(n) * 100}%`;
  }
  return n;
}
function pad2(c) {
  return c.length === 1 ? "0" + c : String(c);
}

// node_modules/@ctrl/tinycolor/dist/module/conversion.js
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if (max === min) {
    s = 0;
    h = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }
  return { h, s, l };
}
function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * (6 * t);
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}
function hslToRgb(h, s, l) {
  let r;
  let g;
  let b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  if (s === 0) {
    g = l;
    b = l;
    r = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return { r: r * 255, g: g * 255, b: b * 255 };
}
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  const v = max;
  const d = max - min;
  const s = max === 0 ? 0 : d / max;
  if (max === min) {
    h = 0;
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }
  return { h, s, v };
}
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  const i = Math.floor(h);
  const f = h - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  const mod = i % 6;
  const r = [v, q, p, p, t, v][mod];
  const g = [t, v, v, q, p, p][mod];
  const b = [p, p, t, v, v, q][mod];
  return { r: r * 255, g: g * 255, b: b * 255 };
}
function rgbToHex(r, g, b, allow3Char) {
  const hex = [
    pad2(Math.round(r).toString(16)),
    pad2(Math.round(g).toString(16)),
    pad2(Math.round(b).toString(16))
  ];
  if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}
function rgbaToHex(r, g, b, a, allow4Char) {
  const hex = [
    pad2(Math.round(r).toString(16)),
    pad2(Math.round(g).toString(16)),
    pad2(Math.round(b).toString(16)),
    pad2(convertDecimalToHex(a))
  ];
  if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function numberInputToObject(color) {
  return {
    r: color >> 16,
    g: (color & 65280) >> 8,
    b: color & 255
  };
}

// node_modules/@ctrl/tinycolor/dist/module/css-color-names.js
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};

// node_modules/@ctrl/tinycolor/dist/module/format-input.js
function inputToRGB(color) {
  let rgb = { r: 0, g: 0, b: 0 };
  let a = 1;
  let s = null;
  let v = null;
  let l = null;
  let ok = false;
  let format = false;
  if (typeof color === "string") {
    color = stringInputToObject(color);
  }
  if (typeof color === "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (Object.prototype.hasOwnProperty.call(color, "a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?";
var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
var CSS_UNIT = `(?:${CSS_NUMBER})|(?:${CSS_INTEGER})`;
var PERMISSIVE_MATCH3 = `[\\s|\\(]+(${CSS_UNIT})[,|\\s]+(${CSS_UNIT})[,|\\s]+(${CSS_UNIT})\\s*\\)?`;
var PERMISSIVE_MATCH4 = `[\\s|\\(]+(${CSS_UNIT})[,|\\s]+(${CSS_UNIT})[,|\\s]+(${CSS_UNIT})[,|\\s]+(${CSS_UNIT})\\s*\\)?`;
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(color) {
  color = color.trim().toLowerCase();
  if (color.length === 0) {
    return false;
  }
  let named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color === "transparent") {
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  }
  let match = matchers.rgb.exec(color);
  if (match) {
    return { r: match[1], g: match[2], b: match[3] };
  }
  match = matchers.rgba.exec(color);
  if (match) {
    return { r: match[1], g: match[2], b: match[3], a: match[4] };
  }
  match = matchers.hsl.exec(color);
  if (match) {
    return { h: match[1], s: match[2], l: match[3] };
  }
  match = matchers.hsla.exec(color);
  if (match) {
    return { h: match[1], s: match[2], l: match[3], a: match[4] };
  }
  match = matchers.hsv.exec(color);
  if (match) {
    return { h: match[1], s: match[2], v: match[3] };
  }
  match = matchers.hsva.exec(color);
  if (match) {
    return { h: match[1], s: match[2], v: match[3], a: match[4] };
  }
  match = matchers.hex8.exec(color);
  if (match) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  match = matchers.hex6.exec(color);
  if (match) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  match = matchers.hex4.exec(color);
  if (match) {
    return {
      r: parseIntFromHex(match[1] + match[1]),
      g: parseIntFromHex(match[2] + match[2]),
      b: parseIntFromHex(match[3] + match[3]),
      a: convertHexToDecimal(match[4] + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  match = matchers.hex3.exec(color);
  if (match) {
    return {
      r: parseIntFromHex(match[1] + match[1]),
      g: parseIntFromHex(match[2] + match[2]),
      b: parseIntFromHex(match[3] + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function isValidCSSUnit(color) {
  return Boolean(matchers.CSS_UNIT.exec(String(color)));
}

// node_modules/@ctrl/tinycolor/dist/module/index.js
var TinyColor = class {
  constructor(color = "", opts = {}) {
    if (color instanceof TinyColor) {
      return color;
    }
    if (typeof color === "number") {
      color = numberInputToObject(color);
    }
    this.originalInput = color;
    const rgb = inputToRGB(color);
    this.originalInput = color;
    this.r = rgb.r;
    this.g = rgb.g;
    this.b = rgb.b;
    this.a = rgb.a;
    this.roundA = Math.round(100 * this.a) / 100;
    this.format = opts.format ?? rgb.format;
    this.gradientType = opts.gradientType;
    if (this.r < 1) {
      this.r = Math.round(this.r);
    }
    if (this.g < 1) {
      this.g = Math.round(this.g);
    }
    if (this.b < 1) {
      this.b = Math.round(this.b);
    }
    this.isValid = rgb.ok;
  }
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return !this.isDark();
  }
  getBrightness() {
    const rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
  }
  getLuminance() {
    const rgb = this.toRgb();
    let R;
    let G;
    let B;
    const RsRGB = rgb.r / 255;
    const GsRGB = rgb.g / 255;
    const BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) {
      R = RsRGB / 12.92;
    } else {
      R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    }
    if (GsRGB <= 0.03928) {
      G = GsRGB / 12.92;
    } else {
      G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    }
    if (BsRGB <= 0.03928) {
      B = BsRGB / 12.92;
    } else {
      B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }
  getAlpha() {
    return this.a;
  }
  setAlpha(alpha) {
    this.a = boundAlpha(alpha);
    this.roundA = Math.round(100 * this.a) / 100;
    return this;
  }
  isMonochrome() {
    const { s } = this.toHsl();
    return s === 0;
  }
  toHsv() {
    const hsv = rgbToHsv(this.r, this.g, this.b);
    return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
  }
  toHsvString() {
    const hsv = rgbToHsv(this.r, this.g, this.b);
    const h = Math.round(hsv.h * 360);
    const s = Math.round(hsv.s * 100);
    const v = Math.round(hsv.v * 100);
    return this.a === 1 ? `hsv(${h}, ${s}%, ${v}%)` : `hsva(${h}, ${s}%, ${v}%, ${this.roundA})`;
  }
  toHsl() {
    const hsl = rgbToHsl(this.r, this.g, this.b);
    return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
  }
  toHslString() {
    const hsl = rgbToHsl(this.r, this.g, this.b);
    const h = Math.round(hsl.h * 360);
    const s = Math.round(hsl.s * 100);
    const l = Math.round(hsl.l * 100);
    return this.a === 1 ? `hsl(${h}, ${s}%, ${l}%)` : `hsla(${h}, ${s}%, ${l}%, ${this.roundA})`;
  }
  toHex(allow3Char = false) {
    return rgbToHex(this.r, this.g, this.b, allow3Char);
  }
  toHexString(allow3Char = false) {
    return "#" + this.toHex(allow3Char);
  }
  toHex8(allow4Char = false) {
    return rgbaToHex(this.r, this.g, this.b, this.a, allow4Char);
  }
  toHex8String(allow4Char = false) {
    return "#" + this.toHex8(allow4Char);
  }
  toHexShortString(allowShortChar = false) {
    return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
  }
  toRgb() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  }
  toRgbString() {
    const r = Math.round(this.r);
    const g = Math.round(this.g);
    const b = Math.round(this.b);
    return this.a === 1 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${this.roundA})`;
  }
  toPercentageRgb() {
    const fmt = (x) => `${Math.round(bound01(x, 255) * 100)}%`;
    return {
      r: fmt(this.r),
      g: fmt(this.g),
      b: fmt(this.b),
      a: this.a
    };
  }
  toPercentageRgbString() {
    const rnd = (x) => Math.round(bound01(x, 255) * 100);
    return this.a === 1 ? `rgb(${rnd(this.r)}%, ${rnd(this.g)}%, ${rnd(this.b)}%)` : `rgba(${rnd(this.r)}%, ${rnd(this.g)}%, ${rnd(this.b)}%, ${this.roundA})`;
  }
  toName() {
    if (this.a === 0) {
      return "transparent";
    }
    if (this.a < 1) {
      return false;
    }
    const hex = "#" + rgbToHex(this.r, this.g, this.b, false);
    for (const [key, value] of Object.entries(names)) {
      if (hex === value) {
        return key;
      }
    }
    return false;
  }
  toString(format) {
    const formatSet = Boolean(format);
    format = format ?? this.format;
    let formattedString = false;
    const hasAlpha = this.a < 1 && this.a >= 0;
    const needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
    if (needsAlphaFormat) {
      if (format === "name" && this.a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  }
  toNumber() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  }
  clone() {
    return new TinyColor(this.toString());
  }
  lighten(amount = 10) {
    const hsl = this.toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return new TinyColor(hsl);
  }
  brighten(amount = 10) {
    const rgb = this.toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return new TinyColor(rgb);
  }
  darken(amount = 10) {
    const hsl = this.toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return new TinyColor(hsl);
  }
  tint(amount = 10) {
    return this.mix("white", amount);
  }
  shade(amount = 10) {
    return this.mix("black", amount);
  }
  desaturate(amount = 10) {
    const hsl = this.toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return new TinyColor(hsl);
  }
  saturate(amount = 10) {
    const hsl = this.toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return new TinyColor(hsl);
  }
  greyscale() {
    return this.desaturate(100);
  }
  spin(amount) {
    const hsl = this.toHsl();
    const hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return new TinyColor(hsl);
  }
  mix(color, amount = 50) {
    const rgb1 = this.toRgb();
    const rgb2 = new TinyColor(color).toRgb();
    const p = amount / 100;
    const rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return new TinyColor(rgba);
  }
  analogous(results = 6, slices = 30) {
    const hsl = this.toHsl();
    const part = 360 / slices;
    const ret = [this];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(new TinyColor(hsl));
    }
    return ret;
  }
  complement() {
    const hsl = this.toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return new TinyColor(hsl);
  }
  monochromatic(results = 6) {
    const hsv = this.toHsv();
    const { h } = hsv;
    const { s } = hsv;
    let { v } = hsv;
    const res = [];
    const modification = 1 / results;
    while (results--) {
      res.push(new TinyColor({ h, s, v }));
      v = (v + modification) % 1;
    }
    return res;
  }
  splitcomplement() {
    const hsl = this.toHsl();
    const { h } = hsl;
    return [
      this,
      new TinyColor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
      new TinyColor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l })
    ];
  }
  onBackground(background2) {
    const fg = this.toRgb();
    const bg = new TinyColor(background2).toRgb();
    const alpha = fg.a + bg.a * (1 - fg.a);
    return new TinyColor({
      r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
      g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
      b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
      a: alpha
    });
  }
  triad() {
    return this.polyad(3);
  }
  tetrad() {
    return this.polyad(4);
  }
  polyad(n) {
    const hsl = this.toHsl();
    const { h } = hsl;
    const result = [this];
    const increment = 360 / n;
    for (let i = 1; i < n; i++) {
      result.push(new TinyColor({ h: (h + i * increment) % 360, s: hsl.s, l: hsl.l }));
    }
    return result;
  }
  equals(color) {
    return this.toRgbString() === new TinyColor(color).toRgbString();
  }
};

// src/semantic-tokens.ts
var utility = {
  "border-color-a11y": {
    default: "blackAlpha.400",
    _dark: "whiteAlpha.400"
  }
};
var neutral = {
  "neutral.50": {
    default: "blackAlpha.50",
    _dark: "whiteAlpha.900"
  },
  "neutral.100": {
    default: "blackAlpha.100",
    _dark: "whiteAlpha.800"
  },
  "neutral.200": {
    default: "blackAlpha.200",
    _dark: "whiteAlpha.700"
  },
  "neutral.300": {
    default: "blackAlpha.300",
    _dark: "whiteAlpha.600"
  },
  "neutral.400": {
    default: "blackAlpha.400",
    _dark: "whiteAlpha.500"
  },
  "neutral.500": {
    default: "blackAlpha.500",
    _dark: "whiteAlpha.400"
  },
  "neutral.600": {
    default: "blackAlpha.600",
    _dark: "whiteAlpha.300"
  },
  "neutral.700": {
    default: "blackAlpha.700",
    _dark: "whiteAlpha.200"
  },
  "neutral.800": {
    default: "blackAlpha.800",
    _dark: "whiteAlpha.100"
  },
  "neutral.900": {
    default: "blackAlpha.900",
    _dark: "whiteAlpha.50"
  },
  "neutral-color.50": {
    default: "blackAlpha.50",
    _dark: "whiteAlpha.100"
  },
  "neutral-color.100": {
    default: "blackAlpha.100",
    _dark: "whiteAlpha.200"
  },
  "neutral-color.200": {
    default: "blackAlpha.200",
    _dark: "whiteAlpha.300"
  },
  "neutral-color.300": {
    default: "blackAlpha.300",
    _dark: "whiteAlpha.400"
  },
  "neutral-color.400": {
    default: "blackAlpha.400",
    _dark: "whiteAlpha.500"
  },
  "neutral-color.500": {
    default: "blackAlpha.500",
    _dark: "whiteAlpha.600"
  },
  "neutral-color.600": {
    default: "blackAlpha.600",
    _dark: "whiteAlpha.700"
  },
  "neutral-color.700": {
    default: "blackAlpha.700",
    _dark: "whiteAlpha.800"
  },
  "neutral-color.800": {
    default: "blackAlpha.800",
    _dark: "whiteAlpha.900"
  },
  "neutral-color.900": {
    default: "blackAlpha.900",
    _dark: "white"
  }
};
var simple = {
  primary: {
    default: "primary.500",
    _dark: "primary.200"
  },
  danger: {
    default: "danger.500",
    _dark: "danger.200"
  },
  error: {
    default: "danger.500",
    _dark: "danger.200"
  },
  success: {
    default: "success.500",
    _dark: "success.200"
  },
  warning: {
    default: "warning.500",
    _dark: "warning.200"
  },
  info: {
    default: "info.500",
    _dark: "info.200"
  },
  neutral: {
    default: "blackAlpha.500",
    _dark: "whiteAlpha.600"
  },
  gray: {
    default: "gray.500",
    _dark: "gray.200"
  },
  red: {
    default: "red.500",
    _dark: "red.200"
  },
  orange: {
    default: "orange.500",
    _dark: "orange.200"
  },
  yellow: {
    default: "yellow.500",
    _dark: "yellow.200"
  },
  green: {
    default: "green.500",
    _dark: "green.200"
  },
  teal: {
    default: "teal.500",
    _dark: "teal.200"
  },
  cyan: {
    default: "cyan.500",
    _dark: "cyan.200"
  },
  blue: {
    default: "blue.500",
    _dark: "blue.200"
  },
  purple: {
    default: "purple.500",
    _dark: "purple.200"
  },
  pink: {
    default: "pink.500",
    _dark: "pink.200"
  }
};
var foreground = {
  "primary-fg": {
    default: "primary.600",
    _dark: "primary.200"
  },
  "danger-fg": {
    default: "danger.600",
    _dark: "danger.200"
  },
  "warning-fg": {
    default: "warning.600",
    _dark: "warning.200"
  },
  "success-fg": {
    default: "success.600",
    _dark: "success.200"
  },
  "info-fg": {
    default: "info.600",
    _dark: "info.200"
  },
  "neutral-fg": {
    default: "blackAlpha.600",
    _dark: "whiteAlpha.700"
  }
};
var background = {
  "primary-bg": {
    default: "primary.100",
    _dark: new TinyColor(colors_default.primary[200]).setAlpha(0.12).toRgbString()
  },
  "danger-bg": {
    default: "danger.100",
    _dark: new TinyColor(colors_default.danger[200]).setAlpha(0.12).toRgbString()
  },
  "error-bg": {
    default: "danger.100",
    _dark: new TinyColor(colors_default.danger[200]).setAlpha(0.12).toRgbString()
  },
  "warning-bg": {
    default: "warning.100",
    _dark: new TinyColor(colors_default.warning[200]).setAlpha(0.12).toRgbString()
  },
  "success-bg": {
    default: "success.100",
    _dark: new TinyColor(colors_default.success[200]).setAlpha(0.12).toRgbString()
  },
  "info-bg": {
    default: "info.100",
    _dark: new TinyColor(colors_default.info[200]).setAlpha(0.12).toRgbString()
  },
  "neutral-bg": {
    default: "blackAlpha.100",
    _dark: "whiteAlpha.200"
  }
};
var backgroundActive = {
  "primary-bg-active": {
    default: "primary.200",
    _dark: new TinyColor(colors_default.primary[200]).setAlpha(0.24).toRgbString()
  },
  "danger-bg-active": {
    default: "danger.200",
    _dark: new TinyColor(colors_default.danger[200]).setAlpha(0.24).toRgbString()
  },
  "warning-bg-active": {
    default: "warning.200",
    _dark: new TinyColor(colors_default.warning[200]).setAlpha(0.24).toRgbString()
  },
  "success-bg-active": {
    default: "success.200",
    _dark: new TinyColor(colors_default.success[200]).setAlpha(0.24).toRgbString()
  },
  "info-bg-active": {
    default: "info.200",
    _dark: new TinyColor(colors_default.info[200]).setAlpha(0.24).toRgbString()
  },
  "neutral-bg-active": {
    default: "blackAlpha.200",
    _dark: "whiteAlpha.300"
  }
};
var semanticTokens = {
  colors: {
    "chakra-body-bg": {
      default: "white",
      _light: "white",
      _dark: "gray.800"
    },
    "chakra-subtle-bg": {
      default: "gray.50",
      _light: "gray.50",
      _dark: "gray.700"
    },
    "chakra-body-text": {
      default: "blackAlpha.900",
      _light: "blackAlpha.900",
      _dark: "white"
    },
    "chakra-subtle-text": {
      default: "blackAlpha.500",
      _light: "blackAlpha.500",
      _dark: "whiteAlpha.600"
    },
    "chakra-placeholder-color": {
      default: "blackAlpha.400",
      _light: "blackAlpha.400",
      _dark: "whiteAlpha.500"
    },
    "chakra-inverse-text": {
      default: "white",
      _light: "white",
      _dark: "blackAlpha.900"
    },
    "chakra-border-color": {
      default: "blackAlpha.200",
      _light: "blackAlpha.200",
      _dark: "whiteAlpha.300"
    },
    ...utility,
    ...foreground,
    ...background,
    ...backgroundActive,
    ...simple,
    ...neutral
  }
};

// src/toast-options.ts
var toastOptions = {
  defaultOptions: {
    position: "bottom-left",
    variant: "subtle",
    containerStyle: {
      bg: "chakra-body-bg",
      rounded: "md",
      mt: "0",
      mb: "4",
      mx: "4"
    }
  }
};
var toast_options_default = toastOptions;

// src/logo-icons.ts
var iconSitecore = "M11.44 17.52C12.38 17.4 13.28 17.11 14.1 16.65C16.13 15.51 17.29 13.58 17.39 11.18V10.96H20.22C20.05 9.53 19.49 8.23 18.7 7.11L15.82 8.95C16.69 10.33 16.81 11.83 16.13 13.35C15.36 15.19 13.52 16.76 11.44 17.51M20.27 11.39H17.83C17.66 13.81 16.4 15.87 14.32 17C13.13 17.65 11.78 17.99 10.4 17.99C9.34 17.99 8.25 17.8 7.21 17.41C8.47 18.18 9.87 18.62 11.32 18.62H11.34C13.95 18.62 16.32 17.24 17.65 14.89L17.77 14.7L19.39 15.74C19.97 14.6 20.29 13.34 20.29 11.99C20.29 11.8 20.27 11.6 20.27 11.39M11.34 19.06C8.7 19.06 6.24 17.75 4.49 15.53C5.82 18.34 8.68 20.3 11.99 20.3C15.06 20.3 17.75 18.63 19.18 16.14L17.9 15.34C16.47 17.66 14.05 19.07 11.34 19.07M11.99 20.74C7.18 20.74 3.26 16.84 3.26 12.01C3.26 7.18 7.16 3.27 12 3.27C16.84 3.27 20.73 7.17 20.73 12C20.73 16.83 16.81 20.73 12 20.73M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z";
var iconCdp = "M14.1099 15.11C13.8899 14.89 13.9199 14.52 14.1899 14.35C15.5099 13.49 16.2999 11.86 15.8999 10.09C15.5799 8.63002 14.3999 7.44002 12.9499 7.11002C10.3299 6.51002 7.99995 8.48002 7.99995 11C7.99995 12.4 8.71995 13.63 9.81995 14.34C10.0799 14.51 10.1199 14.88 9.89995 15.1L9.24995 15.75C7.60995 14.8 6.50995 13.03 6.50995 10.99C6.50995 9.67002 6.97995 8.46002 7.74995 7.52002C7.91995 7.32002 7.91995 7.02002 7.72995 6.84002L5.24995 4.36002C5.04995 4.16002 4.70995 4.16002 4.51995 4.37002C2.61995 6.52002 1.61995 9.49001 2.14995 12.69C2.82995 16.83 6.15995 20.16 10.2999 20.85C12.9899 21.3 15.4999 20.67 17.5199 19.33C17.7799 19.16 17.8099 18.78 17.5899 18.56L14.1299 15.1L14.1099 15.11Z M16.28 6.84003C16.09 7.03003 16.09 7.32003 16.26 7.52003C17.03 8.47003 17.5 9.68003 17.5 10.99C17.5 12.48 16.91 13.83 15.95 14.82L18.76 17.63C18.96 17.83 19.3 17.83 19.49 17.62C21.05 15.86 22 13.54 22 11C22 8.46003 21.05 6.14003 19.49 4.38003C19.3 4.17003 18.96 4.17003 18.76 4.37003L16.28 6.85003V6.84003Z";
var iconCdpPersonalize = "M14.18 15.34C15.5 14.48 16.29 12.85 15.89 11.08C15.57 9.61997 14.39 8.42997 12.94 8.09997C10.32 7.49997 7.99003 9.46997 7.99003 11.99C7.99003 13.39 8.71003 14.62 9.81003 15.33C10.07 15.5 10.11 15.87 9.89003 16.09L6.43003 19.55C6.21003 19.77 6.24003 20.15 6.50003 20.32C8.08003 21.37 9.97003 21.98 12 21.98C14.03 21.98 15.92 21.36 17.5 20.32C17.76 20.15 17.79 19.77 17.57 19.55L14.36 16.34C13.88 15.86 13.92 15.49 14.18 15.32V15.34Z M10.87 2.06C6.23004 2.57 2.48004 6.39 2.05004 11.03C1.77004 13.95 2.76004 16.64 4.52004 18.63C4.71004 18.84 5.04004 18.84 5.25004 18.64L8.06004 15.83C6.83004 14.56 6.20004 12.7 6.65004 10.72C7.10004 8.74 8.77004 7.06 10.81 6.63C14.37 5.88 17.51 8.58 17.51 12C17.51 13.49 16.92 14.84 15.96 15.83L18.77 18.64C18.97 18.84 19.31 18.84 19.5 18.63C21.06 16.87 22.01 14.55 22.01 12.01C22 6.1 16.9 1.4 10.87 2.06Z";
var iconComponents = "M21.5899 7.37H15.4799L11.6999 11.87H5.3999L2.2799 15.59C2.1699 15.72 2.2599 15.92 2.4299 15.92H11.0699L8.2399 19.29C8.1299 19.42 8.2199 19.62 8.3899 19.62H16.7399C16.8899 19.62 17.0299 19.55 17.1199 19.44L21.7299 13.95C21.8399 13.82 21.7499 13.62 21.5799 13.62H16.7599L21.7299 7.7C21.8399 7.57 21.7499 7.37 21.5799 7.37H21.5899Z M15.6099 4.37H7.24991C7.09991 4.37 6.95991 4.44 6.86991 4.55L2.25991 10.05C2.14991 10.18 2.23991 10.38 2.40991 10.38H10.7699C10.9199 10.38 11.0599 10.31 11.1499 10.2L15.7599 4.71C15.8699 4.58 15.7799 4.38 15.6099 4.38V4.37Z";
var iconConnect = "M21 16.91V7.09C21 6.91 20.9 6.75 20.75 6.66L12.25 1.75C12.1 1.66 11.9 1.66 11.75 1.75L7.06998 4.45L8.06998 6.18L8.93998 5.68C10.37 4.85 12.21 5.35 13.04 6.78C13.87 8.21 13.37 10.05 11.94 10.88L11.07 11.38L12.07 13.11L12.94 12.61C14.37 11.78 16.21 12.28 17.04 13.71C17.87 15.14 17.37 16.98 15.94 17.81L15.07 18.31L16.07 20.04L20.75 17.34C20.9 17.25 21 17.09 21 16.91Z M13.68 13.92L11.51 15.17L9.00999 10.84L11.18 9.59002C11.9 9.18002 12.14 8.26002 11.73 7.54002C11.32 6.82002 10.4 6.58002 9.67999 6.99002L7.50999 8.24002L5.75999 5.21002L3.23999 6.66002C3.08999 6.75002 2.98999 6.91002 2.98999 7.09002V16.9C2.98999 17.08 3.08999 17.24 3.23999 17.33L11.74 22.24C11.89 22.33 12.09 22.33 12.24 22.24L14.76 20.79L13.01 17.76L15.18 16.51C15.9 16.1 16.14 15.18 15.73 14.46C15.32 13.74 14.4 13.5 13.68 13.91V13.92Z";
var iconContentHub = "M7.5 14.271L15 8.37798V3.84998C15 3.78698 14.97 3.72798 14.92 3.68998L12.12 1.58998C12.049 1.53698 11.951 1.53698 11.88 1.58998L9.08 3.68998C9.03 3.72798 9 3.78698 9 3.84998V10.286L4.6 6.82798C4.539 6.77998 4.456 6.77198 4.387 6.80698L1.611 8.19498C1.543 8.22898 1.5 8.29798 1.5 8.37398V11.904C1.5 11.965 1.528 12.022 1.575 12.06L7.5 16.8V14.271Z M9 15.097V22C9 22.276 9.224 22.5 9.5 22.5H14.5C14.776 22.5 15 22.276 15 22V18L22.425 12.06C22.472 12.022 22.5 11.965 22.5 11.904V8.37397C22.5 8.29797 22.457 8.22897 22.389 8.19497L19.613 6.80697C19.544 6.77197 19.461 6.77997 19.4 6.82797L9.076 14.94C9.028 14.978 9 15.036 9 15.097Z";
var iconContentHubOne = "M8 22H16.76C16.91 22 17.06 21.93 17.15 21.81L19 19.5H10.24C10.09 19.5 9.94 19.57 9.85 19.69L8 22Z M7 14V16.9C7 17.01 6.96 17.13 6.89 17.22L3 22.01H5.76C5.91 22.01 6.05 21.94 6.15 21.83L9.1 18.2C9.19 18.08 9.34 18.02 9.49 18.02H12.5C15.92 18.02 18.72 15.38 18.97 12.02H15L18.89 7.16C18.96 7.07 19 6.96 19 6.85V2C12.37 2 7 7.37 7 14Z";
var iconContentHubDam = "M12.7701 7.42998L10.5901 21.74L19.5501 16.57C19.6801 16.49 19.7701 16.36 19.7901 16.21L21.8501 2.71998C21.9001 2.38998 21.5501 2.14998 21.2501 2.30998L13.0101 7.06998C12.8801 7.14998 12.7901 7.27998 12.7701 7.42998Z M10.9501 9.40996L5.11009 12.78C4.88009 12.91 4.79009 13.21 4.92009 13.45L5.57009 14.66L2.40009 16.49C2.07009 16.68 2.07009 17.16 2.40009 17.35L9.13009 21.35V21.33L10.9601 9.39996L10.9501 9.40996Z";
var iconContentHubOperations = "M11.5 14.81L18.41 18.7L20.75 17.35C20.9 17.26 21 17.1 21 16.92V7.09001C21 6.91001 20.9 6.75001 20.75 6.66001L18.43 5.32001L11.5 9.25001V14.81Z M10 15.68V8.35999L16.92 4.44L12.25 1.75C12.1 1.66 11.9 1.66 11.75 1.75L3.25 6.66C3.1 6.75 3 6.91 3 7.09V16.9C3 17.08 3.1 17.24 3.25 17.33L11.75 22.24C11.9 22.33 12.1 22.33 12.25 22.24L16.9 19.56L10 15.68Z";
var iconDiscover = "M18.5 6V18H21.5C21.78 18 22 17.78 22 17.5V6.5C22 6.22 21.78 6 21.5 6H18.5Z M2.5 18H5.5V6H2.5C2.22 6 2 6.22 2 6.5V17.5C2 17.78 2.22 18 2.5 18Z M16.5 4H7.5C7.22386 4 7 4.22386 7 4.5V19.5C7 19.7761 7.22386 20 7.5 20H16.5C16.7761 20 17 19.7761 17 19.5V4.5C17 4.22386 16.7761 4 16.5 4Z";
var iconExplorer = "M10.964 14.625H5.28101L2.42301 19.575C2.34601 19.708 2.44201 19.875 2.59601 19.875H10.211C10.39 19.875 10.555 19.78 10.644 19.625L12.232 16.875H16.172C16.371 16.875 16.551 16.757 16.631 16.574L18.781 11.625H12.464L10.964 14.625Z M10.036 13.125L11.536 10.125H19.5L22.355 4.414C22.421 4.281 22.325 4.125 22.176 4.125H14.546C14.363 4.125 14.195 4.225 14.107 4.385L12.2 7.875H4.82001C4.64101 7.875 4.47601 7.97 4.38701 8.125L1.67301 12.825C1.59601 12.958 1.69201 13.125 1.84601 13.125H10.036Z";
var iconForms = "M2 4.5C2 4.22386 2.22386 4 2.5 4H21.5C21.7761 4 22 4.22386 22 4.5V10.5C22 10.7761 21.7761 11 21.5 11H2.5C2.22386 11 2 10.7761 2 10.5V4.5Z M2 13C2 12.7239 2.22386 12.5 2.5 12.5H13.5C13.7761 12.5 14 12.7239 14 13V19C14 19.2761 13.7761 19.5 13.5 19.5H2.5C2.22386 19.5 2 19.2761 2 19V13Z";
var iconOrdercloud = "M10.5001 10.83L15.6201 7.87002V2.01002C15.6201 1.78002 15.3701 1.63002 15.1701 1.75002L8.42009 5.65002C8.33009 5.70002 8.27009 5.80002 8.27009 5.91002V9.54002L3.04009 6.52002C2.84009 6.40002 2.59009 6.55002 2.59009 6.78002V16.68C2.59009 16.79 2.65009 16.89 2.74009 16.94L10.5001 21.42V10.83Z M12.0001 22.29L21.2601 16.94C21.3501 16.89 21.4101 16.79 21.4101 16.68V6.78004C21.4101 6.55004 21.1601 6.40004 20.9601 6.52004L12.0001 11.7V22.3V22.29Z";
var iconPages = "M14.117 14.711H6.84598L4.16898 17.723C4.05398 17.852 4.14598 18.056 4.31798 18.056H15.865C16.008 18.056 16.144 17.995 16.239 17.888L22.253 11.122C22.368 10.993 22.276 10.789 22.104 10.789H17.828L14.491 14.543C14.396 14.65 14.26 14.711 14.117 14.711Z M19.682 5.94397H8.13498C7.99198 5.94397 7.85598 6.00497 7.76098 6.11197L1.74698 12.878C1.63198 13.007 1.72398 13.211 1.89598 13.211H13.443C13.586 13.211 13.722 13.15 13.817 13.043L19.831 6.27697C19.946 6.14797 19.854 5.94397 19.682 5.94397ZM7.89698 10.703L9.89698 8.45297H13.68L11.68 10.703H7.89698Z";
var iconPersonalize = "M12 6.01007V2.51007C12 2.22007 11.76 1.99007 11.48 2.00007C6.2 2.27007 2 6.64007 2 11.9901C2 15.4801 3.79 18.5501 6.5 20.3401V11.9901C6.5 9.11007 8.71 6.75007 11.52 6.51007C11.79 6.49007 12 6.28007 12 6.01007Z M17.48 12.4601C17.24 15.2701 14.88 17.4801 12 17.4801V16.4501C12 16.1901 12.21 15.9901 12.46 15.9601C14.75 15.7001 16.45 13.5001 15.89 11.0401C15.56 9.59005 14.39 8.42005 12.94 8.09005C10.32 7.49005 8 9.47005 8 11.9801V20.8001C8 21.0101 8.12 21.2001 8.31 21.2701C9.45 21.7201 10.69 21.9801 12 21.9801C17.35 21.9801 21.72 17.7801 21.99 12.5001C22 12.2201 21.77 11.9801 21.49 11.9801H18.25C17.71 11.9801 17.51 12.1901 17.48 12.4601Z";
var iconSearch = "M20.85 14.9001L21.73 4.29006C21.73 4.18006 21.66 4.08006 21.55 4.07006L10.99 3.15006C10.86 3.14006 10.73 3.18006 10.63 3.27006L2.68998 9.92006C2.55998 10.0301 2.61998 10.2401 2.77998 10.2701L6.84998 10.9901C7.33998 8.34006 9.72998 6.35006 12.56 6.50006C15.39 6.65006 17.7 9.06006 17.75 11.8801C17.81 14.9301 15.38 17.4301 12.35 17.4801V21.7301C12.35 21.9001 12.55 21.9901 12.68 21.8801L20.66 15.2201C20.76 15.1301 20.83 15.0101 20.84 14.8801L20.85 14.9001Z M12.26 16.0001C14.4691 16.0001 16.26 14.2092 16.26 12.0001C16.26 9.79092 14.4691 8.00006 12.26 8.00006C10.0508 8.00006 8.25998 9.79092 8.25998 12.0001C8.25998 14.2092 10.0508 16.0001 12.26 16.0001Z";
var iconSend = "M2.91001 14.1501L18.22 3.31006L7.46001 16.1301L2.96001 14.4901C2.81001 14.4301 2.78001 14.2301 2.91001 14.1401V14.1501Z M6.3499 19.8601L20.2199 3.31006V20.4901C20.2199 20.6301 20.0799 20.7301 19.9499 20.6801L13.5599 18.3601L6.5499 20.1901C6.3599 20.2401 6.2199 20.0201 6.3499 19.8701V19.8601Z";
var iconXmCloud = "M3.08002 18.14L5.65002 20.71C5.75002 20.81 5.88002 20.86 6.00002 20.86C6.12002 20.86 6.26002 20.81 6.35002 20.71C7.91002 19.15 9.95002 18.37 11.99 18.37C14.03 18.37 16.07 19.15 17.63 20.71C17.73 20.81 17.86 20.86 17.98 20.86C18.1 20.86 18.24 20.81 18.33 20.71L20.9 18.14C21.25 17.79 21.25 17.21 20.9 16.86L14.81 10.77C14.03 9.99001 13.01 9.60001 11.98 9.60001C10.95 9.60001 9.93002 9.99001 9.15002 10.77L3.06002 16.86C2.71002 17.21 2.71002 17.79 3.06002 18.14H3.08002Z M6.87001 10.94L8.11001 9.70001C9.15001 8.66001 10.53 8.09001 12 8.09001C13.47 8.09001 14.85 8.66001 15.89 9.70001L17.13 10.94L21.21 6.86001C21.41 6.66001 21.41 6.35001 21.21 6.15001L18.35 3.29001C18.15 3.09001 17.84 3.09001 17.64 3.29001C14.52 6.41001 9.47001 6.41001 6.36001 3.29001C6.16001 3.09001 5.85001 3.09001 5.65001 3.29001L2.79001 6.15001C2.59001 6.35001 2.59001 6.66001 2.79001 6.86001L6.87001 10.94Z";
var iconXmCloudDeploy = "M3.08002 18.14L5.65002 20.71C5.75002 20.81 5.88002 20.86 6.00002 20.86C6.12002 20.86 6.26002 20.81 6.35002 20.71C7.91002 19.15 9.95002 18.37 11.99 18.37C14.03 18.37 16.07 19.15 17.63 20.71C17.73 20.81 17.86 20.86 17.98 20.86C18.1 20.86 18.24 20.81 18.33 20.71L20.9 18.14C21.25 17.79 21.25 17.21 20.9 16.86L14.81 10.77C14.03 9.99001 13.01 9.60001 11.98 9.60001C10.95 9.60001 9.93002 9.99001 9.15002 10.77L3.06002 16.86C2.71002 17.21 2.71002 17.79 3.06002 18.14H3.08002Z M6.87001 10.94L8.11001 9.70001C9.15001 8.66001 10.53 8.09001 12 8.09001C13.47 8.09001 14.85 8.66001 15.89 9.70001L17.13 10.94L21.21 6.86001C21.41 6.66001 21.41 6.35001 21.21 6.15001L18.35 3.29001C18.15 3.09001 17.84 3.09001 17.64 3.29001C14.52 6.41001 9.47001 6.41001 6.36001 3.29001C6.16001 3.09001 5.85001 3.09001 5.65001 3.29001L2.79001 6.15001C2.59001 6.35001 2.59001 6.66001 2.79001 6.86001L6.87001 10.94Z";

// src/index.ts
var config = {
  initialColorMode: "light",
  cssVarPrefix: ""
};
var sitecoreTheme = extendTheme({
  config,
  ...foundations_default,
  components: components_default,
  styles: styles_default,
  layerStyles: layer_styles_default,
  semanticTokens
});
var src_default = sitecoreTheme;
export {
  src_default as default,
  iconCdp,
  iconCdpPersonalize,
  iconComponents,
  iconConnect,
  iconContentHub,
  iconContentHubDam,
  iconContentHubOne,
  iconContentHubOperations,
  iconDiscover,
  iconExplorer,
  iconForms,
  iconOrdercloud,
  iconPages,
  iconPersonalize,
  iconSearch,
  iconSend,
  iconSitecore,
  iconXmCloud,
  iconXmCloudDeploy,
  toast_options_default as toastOptions
};
